import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconChevronTriangleLeftMedium: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="chevron-triangle-left-medium, dropdown, caret"><path d="M12.124 7.55579C13.2624 6.59964 14.9995 7.40917 15 8.89563V15.1046C14.9996 16.5912 13.2624 17.4007 12.124 16.4445L8.4287 13.34C7.59673 12.6406 7.59664 11.3595 8.4287 10.6603L12.124 7.55579Z" fill="currentColor"/></CentralIconBase>;
};

export default IconChevronTriangleLeftMedium;
